// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3cev9{background:#f4f7fa;border-radius:8px;color:#001f5b;display:inline-block;font-size:12px;font-size:1.2rem;font-weight:700;padding:.333em 1em}._2ngX8{color:#5e6e97}._1iB3E{background:#d0f7ed;color:#14866e}._3q-u5{background:#feefef;color:#da1818}", ""]);
// Exports
exports.locals = {
	"chip": "_3cev9",
	"chip--inactive": "_2ngX8",
	"chip--success": "_1iB3E",
	"chip--error": "_3q-u5"
};
module.exports = exports;
